// extracted by mini-css-extract-plugin
module.exports = {"welcome":"lobby_welcome__3lih6"};